import React, { useState, useMemo, useRef } from 'react';
import LineMarkClickChart from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/LineMarkClickChart';
import { formatDateStr } from '@intelligence/v3/utils/date';

const Visualis: React.FC<any> = (props: any) => {
  const {
    dateType,
    currentType,
    dataSource,
    isPolishing,
    baseReleaseTime,
    earliestPeriod,
    islowerGame = false,
    lowerGameTime,
    dateValue,
    lineData,
    getMetricTitle,
    trendSwitch,
    trendLoading,
    firstWeekSinceReleaseDates = [],
    enableOpinionEventAnnotation = false,
    controlledEventAnnotation,
  } = props;

  // console.log('Visualis', props);

  // 按metrics名称组装数据，不要按顺序
  const chartDataList = useMemo(() => {
    if (firstWeekSinceReleaseDates.length) {
      return firstWeekSinceReleaseDates.map((date: string) => {
        const dateItem = lineData?.find((item: any) => {
          return formatDateStr(item?.time) === date;
        });
        let metricData = {};
        if (currentType === 'activeusers') {
          metricData = dateItem?.metrics?.find((item: any) => item?.metric == 'dau');
        } else if (currentType === 'revenue') {
          metricData = dateItem?.metrics?.find((item: any) => item?.metric == 'revenue');
        } else if (currentType === 'downloads') {
          metricData = dateItem?.metrics?.find((item: any) => item?.metric == 'download');
        }
        return {
          time: date,
          data: metricData,
        };
      });
    }

    const list: any[] = [];
    if (Array.isArray(lineData) && lineData?.length > 0) {
      for (const i in lineData) {
        if (
          lineData[i].metrics &&
          Array.isArray(lineData[i].metrics) &&
          lineData[i].metrics?.length > 0
        ) {
          let dauData = {};
          if (currentType === 'activeusers') {
            dauData = lineData[i].metrics.find((item: any) => item.metric == 'dau');
          } else if (currentType === 'revenue') {
            dauData = lineData[i].metrics.find((item: any) => item.metric == 'revenue');
          } else if (currentType === 'downloads') {
            dauData = lineData[i].metrics.find((item: any) => item.metric == 'download');
          }
          list.push({
            time: lineData[i].time,
            data: dauData,
          });
        }
      }
    }
    return list;
  }, [lineData, currentType, dateType, firstWeekSinceReleaseDates]);

  // 按metrics名称组装数据，不要按顺序
  const chartRankDataList = useMemo(() => {
    if (firstWeekSinceReleaseDates.length) {
      return firstWeekSinceReleaseDates.map((date: string) => {
        const dateItem = lineData?.find((item: any) => {
          return formatDateStr(item?.time) === date;
        });
        return {
          time: date,
          data: dateItem?.metrics?.find((item: any) => item?.metric == 'rank'),
        };
      });
    }

    const list: any[] = [];
    if (Array.isArray(lineData) && lineData?.length > 0) {
      for (const i in lineData) {
        if (
          lineData[i].metrics &&
          Array.isArray(lineData[i].metrics) &&
          lineData[i].metrics?.length > 0
        ) {
          let dauData = {};
          dauData = lineData[i].metrics.find((item: any) => item.metric == 'rank');
          list.push({
            time: lineData[i].time,
            data: dauData,
          });
        }
      }
    }
    return list;
  }, [lineData, dateType, firstWeekSinceReleaseDates]);

  const cardRef = useRef(null);

  const lineChartData = useMemo(() => {
    const datalineArr: any = [];
    const datalineRankArr: any = [];
    // 补齐数据标识集合
    // let predictArr: any = [];

    const predictArr: any[][] = [];
    // let predictRankArr: any[][] = [];
    // 当天是否有补齐数据
    let predictByDayArr: any = [];
    // let predictRankByDayArr: any = [];

    // 缓存第一个系列每天补齐数据状态
    predictByDayArr = chartDataList?.map((item: any) => item?.data?.b_predict);
    // predictRankByDayArr = chartRankDataList?.map((item: any) => item?.data?.b_predict);

    // for (let i in lineData) {
    // if (i == 0 && lineData[i]) {
    // 缓存第一个系列每天补齐数据状态
    // predictByDayArr = lineData[i]?.map((item: any) => item?.predict);
    // }
    const pArr: any[] = [];
    const rankPArr: any[] = [];
    chartDataList?.map((item: any, itemIndex: number) => {
      datalineArr.push(item?.data?.value);
      // console.log('item?.data?.b_predict ? 1 : 0', item?.data?.b_predict ? 1 : 0);
      const num = item?.data?.b_predict ? 1 : 0;
      pArr.push(num);
      // pArr.push(item?.data?.b_predict);
      // 当天当前系列不是补齐数据且当天下一系列是补齐数据
      if (predictByDayArr[itemIndex] !== 1 && item?.data?.b_predict) {
        predictByDayArr[itemIndex] = 1;
      } else {
        predictByDayArr[itemIndex] = 0;
      }
    });
    chartRankDataList?.map((item: any, itemIndex: number) => {
      datalineRankArr.push(item?.data?.value);
      const num = item?.data?.b_predict ? 1 : 0;
      // rankPArr.push(num);
      // pArr.push(item?.data?.b_predict);
      // 当天当前系列不是补齐数据且当天下一系列是补齐数据
      // if (predictByDayArr[itemIndex] !== 1 && item?.data?.b_predict) {
      //   predictByDayArr[itemIndex] = 1
      // }
    });
    // datalineArr.push(itemArr);
    predictArr.push(pArr);
    // predictRankArr.push(rankPArr);
    // }
    const dateLineArr =
      chartDataList?.length > 0 ? chartDataList?.map((item: any) => item.time) || [] : [];
    const nameLineArr = [getMetricTitle(currentType, dateType)];

    return {
      datalineArr,
      datalineRankArr,
      predictArr,
      // predictRankArr: predictRankArr,
      nameLineArr,
      dateLineArr,
      predictByDayArr,
    };
  }, [chartDataList, trendSwitch]);

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <LineMarkClickChart
          chartYData={
            trendSwitch
              ? [lineChartData.datalineArr, lineChartData.datalineRankArr]
              : [lineChartData.datalineArr]
          }
          predictArr={
            trendSwitch
              ? [...lineChartData.predictArr, ...lineChartData.predictArr]
              : [...lineChartData.predictArr]
          }
          height={'350px'}
          chartId={'LineChart'}
          lengendArr={
            trendSwitch ? [...lineChartData.nameLineArr, 'Rank'] : [...lineChartData.nameLineArr]
          }
          chartXData={lineChartData.dateLineArr}
          dateType={dateType}
          platform={dataSource}
          currentType={currentType}
          isPolishing={isPolishing}
          baseReleaseTime={baseReleaseTime}
          earliestPeriod={earliestPeriod}
          isShowReleaseTime={true}
          islowerGame={islowerGame}
          lowerGameTime={lowerGameTime}
          dateValue={dateValue}
          predictByDayArr={lineChartData.predictByDayArr}
          trendLoading={trendLoading}
          enableOpinionEventAnnotation={enableOpinionEventAnnotation}
          controlledEventAnnotation={controlledEventAnnotation}
        />
      </div>
    </>
  );
};

export default Visualis;
